export const API_URL_CONFIG = 'https://devapiadmin.visaka.io/api/';
export const GEOSERVICE_API = 'https://devservices.visaka.io/api/';
export const isProduction = 'false';
export const ASSET_URL_CONFIG = '';
export const ASSET_CONTAINER_NAME = '';
export const AZURE_WEBAPP_PACKAGE_PATH = 'dev';
export const AZURE_WEBAPP_SLOT_NAME = 'visaka-adminpanel-frontend-dev';
export const AZURE_WEBAPP_NAME = 'vil-mobileapp';
export const CLIENT_ID = 'VISAKAADMIN_69095842';
export const CLIENT_SECRET = '11751a30665e13f369924ace03f3b939';
